// src/App.jsx
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';

import Header from './components/Header';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import Tracking from './components/Tracking';

import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AccountPage from './pages/AccountPage';
import StatsPage from './pages/StatsPage';
import Home from './pages/Home';
import TokensPage from './pages/TokensPage';
import ShopPage from './pages/ShopPage';
import AboutPage from './pages/AboutPage';
import AvisoLegal from './pages/AvisoLegal';
import PoliticaCookies from './pages/PoliticaCookies';
import PoliticaPrivacidad from './pages/PoliticaPrivacidad';
import PoliticaTienda from './pages/PoliticaTienda';

import AdminOrders from './components/AdminOrders';
import NotFound from './components/NotFound';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import OrderDetailPage from './pages/OrderDetailPage';

import "@solana/wallet-adapter-react-ui/styles.css";

const BotRedirect = () => {
  useEffect(() => {
    window.location.href = 'https://reanimeitor.com/blog/reanimeitor-ia/';
  }, []);

  return null;
};

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="app-container">
          <Tracking />

          <Header />

          <Routes>
            {/* Rutas principales */}
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />

            {/* Ruta de seguridad para el bot de WordPress */}
            <Route path="/reanimeitor-ia" element={<BotRedirect />} />
            <Route path="/reanimeitor-ia/" element={<BotRedirect />} />

            <Route path="/tokens" element={<TokensPage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/account" element={<AccountPage />} />

            {/* Panel privado de estadísticas */}
            <Route path="/stats" element={<StatsPage />} />

            {/* Detalle de pedido */}
            <Route path="/order/:id" element={<OrderDetailPage />} />

            <Route path="/about" element={<AboutPage />} />

            {/* Recuperar contraseña */}
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Rutas legales */}
            <Route path="/aviso-legal" element={<AvisoLegal />} />
            <Route path="/politica-cookies" element={<PoliticaCookies />} />
            <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
            <Route path="/politica-tienda" element={<PoliticaTienda />} />

            {/* Ruta oculta para ADMIN */}
            <Route path="/home/config_view_products" element={<AdminOrders />} />

            {/* Página 404 */}
            <Route path="/404" element={<NotFound />} />

            {/* Redirección para cualquier ruta no definida */}
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>

          <Footer />
          <CookieBanner />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;